/**
 * Live Email API Test Suite Page
 * 
 * Complete testing harness for all email operations, AI agents, and workflows
 */

import React from 'react';
import { TestRunner } from '../components/TestRunner';

export default function ApiTestSuite() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">
            🧪 Live Email API Test Suite
          </h1>
          <p className="text-slate-400">
            Comprehensive testing of all email operations, AI agent orchestration, and database queries
          </p>
        </div>

        <TestRunner />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
            <h3 className="text-lg font-semibold text-white mb-3">📧 Email Operations</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>✓ Send emails (Gmail & Outlook)</li>
              <li>✓ Search with filters</li>
              <li>✓ Create & manage drafts</li>
              <li>✓ Star, archive, label</li>
              <li>✓ Reply & forward</li>
            </ul>
          </div>

          <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
            <h3 className="text-lg font-semibold text-white mb-3">🤖 AI Agents</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>✓ GPT-5 Nano Agent</li>
              <li>✓ User intent parsing</li>
              <li>✓ Action orchestration</li>
              <li>✓ Unified AI service</li>
              <li>✓ Workflow automation</li>
            </ul>
          </div>

          <div className="bg-slate-800 rounded-lg p-6 border border-slate-700">
            <h3 className="text-lg font-semibold text-white mb-3">🗄️ Database & Auth</h3>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>✓ OAuth tokens validation</li>
              <li>✓ Graph API authentication</li>
              <li>✓ CRUD operations</li>
              <li>✓ Query optimization</li>
              <li>✓ Schema validation</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 bg-blue-900/30 border border-blue-700 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-blue-200 mb-2">ℹ️ About This Test Suite</h3>
          <p className="text-blue-100 text-sm">
            This comprehensive test suite validates all email operations using real stored authentication tokens 
            from your database. It tests Graph API calls, AI agent orchestration, database queries, and complex 
            multi-step workflows. Results are saved to an HTML report for download.
          </p>
        </div>
      </div>
    </div>
  );
}
